module.exports = __webpack_public_path__ + "static/media/bcio.835d642f.svg";